import React from "react";
import { Segment, Icon, Dimmer, Loader, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import * as phases from "../../../utils/helpers/phases";
export const ConfirmEmailComponent = ({ phase, t }) => (
  <Segment basic style={phase !== phases.LOADED ? { display: "none" } : {}}>
    <Dimmer active={phase === phases.LOADING} page>
      <Loader size="big" />
    </Dimmer>
    <Icon name="checkmark" size="huge" color="orange" circular inverted />
    <Header as="h1" style={{ color: "white" }}>
      {t("confirmEmail:confirmEmailText")}
    </Header>
    <Link to="/login">
      <h4> {t("confirmEmail:backToLoginText")}</h4>
    </Link>
  </Segment>
);



// WEBPACK FOOTER //
// ./src/users/loggedUser/ConfirmEmail/ConfirmEmailComponent.js